/* Predefined filter types:
 * includesString
 * includesStringSensitive
 * equalsString
 * equalsStringSensitive
 * arrIncludes
 * arrIncludesAll
 * arrIncludesSome
 * equals
 * weakEquals
 * inNumberRange
 */
const TableFilterTypes = {
	multiSelection: 'multiSelection',
	float: 'float',
	rating: 'rating'
};

export default TableFilterTypes;
